import { useLang } from "@/contexts/LangContext";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center rounded-full border border-white/15 bg-white/[0.04] p-1 ${className}`}
    >
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1 rounded-full text-xs font-display font-bold transition ${
          lang === "en" ? "bg-[#00ff41] text-black" : "text-neutral-300 hover:text-white"
        }`}
      >
        EN
      </button>
      <button
        data-testid="lang-fr"
        onClick={() => setLang("fr")}
        className={`px-3 py-1 rounded-full text-xs font-display font-bold transition ${
          lang === "fr" ? "bg-[#00ff41] text-black" : "text-neutral-300 hover:text-white"
        }`}
      >
        FR
      </button>
    </div>
  );
};

export default LangToggle;
